export default "__VITE_ASSET__lPbGpbrY__"